import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core'
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser'
import { NgbModal } from '@ng-bootstrap/ng-bootstrap'
import { AuthService, Category, ProductReference, ProductReferenceService } from '@spartacus/core'
import { CurrentProductService, ProductDetailOutlets } from '@spartacus/storefront'
import { Observable, of, Subscription } from 'rxjs'
import { map, take } from 'rxjs/operators'
import { ModalType } from '../../../models/enum/modal.enum'
import { VideoHost } from '../../../models/enum/video.enum'
import { ICustomProduct, UomMapping } from '../../../models/interface/product.interface'
import { Modal } from '../../../models/modal.model'
import { ProductDetailsService } from '../../../services/product.service'
import { SharedService } from '../../../services/shared/shared.service'
import { UserPermissionService } from '../../../services/user-permission/user-permission.service'
import { ModalComponent } from '../../shared/modal/modal.component'

@Component({
    selector: 'app-custom-product-summary',
    templateUrl: './custom-product-summary.component.html',
    styleUrls: ['./custom-product-summary.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class CustomProductSummaryComponent implements OnInit, OnDestroy {
  outlets = ProductDetailOutlets

  product$: Observable<ICustomProduct>

  // product$: Observable<ICustomProduct> = this.productDetailsService.getProductDetail$();
  //vimal
  public spinner = false
  isLoggedIn$: Observable<boolean>
  // test
  private subscriptions: Subscription

  constructor(
    protected currentProductService: CurrentProductService,
    private modalService: NgbModal,
    private sanitizer: DomSanitizer,
    protected productReferenceService: ProductReferenceService,
    private authService: AuthService,
    public userPermissionService: UserPermissionService,
    public sharedService: SharedService,
    public productDetailsService: ProductDetailsService
  ) {}

  ngOnInit(): void {
    this.product$ = this.productDetailsService.getProductDetail$()

    this.isLoggedIn$ = this.authService.isUserLoggedIn()

    this.subscriptions = this.productDetailsService.getProductDetail().subscribe()
  }

  ngOnDestroy(): void {
    if (this.subscriptions) {
      this.subscriptions.unsubscribe()
    }
  }

  public open(product: ICustomProduct): void {
    const modalRef = this.modalService.open(ModalComponent)
    const modal: Modal = new Modal()
    modal.type = ModalType.video
    if (product.videoURL) {
      const safeVideoURL: SafeResourceUrl = this.sanitizer.bypassSecurityTrustResourceUrl(product?.videoURL)
      modal.data = {
        title: product.name,
        videoHostingService: VideoHost.YOUTUBE,
        videoURL: safeVideoURL
      }
    } else {
      modal.data = {
        title: product.name,
        error: 'Video is not provided'
      }
    }
    modalRef.componentInstance.data = modal
  }

  public getProductUomMappings(productUomMappings: UomMapping[]): string {
    let uomMappings: string = ''

    if (productUomMappings && productUomMappings.length > 0) {
      productUomMappings.forEach((uomMapping) => {
        if (uomMapping.qtyConversion > 1) {
          uomMappings =
            uomMappings +
            `1 ${uomMapping.toUnitName} is ${uomMapping.qtyConversion}  ${uomMapping.fromUnitPluralName} \r\n`
        } else {
          uomMappings =
            uomMappings + `1 ${uomMapping.toUnitName} is ${uomMapping.qtyConversion}  ${uomMapping.fromUnitName} \r\n`
        }
      })
    }
    return uomMappings
  }

  public getProductCategoryCode(productCategories: Category[]): string {
    let categoryCodes: string = ''

    if (productCategories && productCategories.length > 0) {
      productCategories.forEach((productCategory) => {
        categoryCodes = categoryCodes + `${productCategory.code} \r\n`
      })
    }
    return categoryCodes
  }

  public getProductCategoryName(productCategories: Category[]): string {
    let categoryNames: string = ''

    if (productCategories && productCategories.length > 0) {
      productCategories.forEach((productCategory) => {
        categoryNames = categoryNames + `${productCategory.name} \r\n`
      })
    }
    return categoryNames
  }

  public getProductReferenceData(productCode: string, referenceType: string): string {
    let productReferenceData: string = ''
    const productReferences = this.productReferenceService
      .getProductReferences(productCode, referenceType)
      .pipe(
        take(1),
        map((references: ProductReference[]) => {
          references.map((reference) => of(reference.target))
          if (references && references.length > 0) {
            references.forEach((reference) => {
              productReferenceData = productReferenceData + `${reference?.target?.name} \r\n`
            })
          }
        })
      )
      .subscribe()

    return productReferenceData
  }
}
